/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CreateOrganization400Response,
  UpdatePLanRequest,
} from '../models/index';
import {
    CreateOrganization400ResponseFromJSON,
    CreateOrganization400ResponseToJSON,
    UpdatePLanRequestFromJSON,
    UpdatePLanRequestToJSON,
} from '../models/index';

export interface UpdatePLanOperationRequest {
    updatePLanRequest: UpdatePLanRequest;
}

/**
 * 
 */
export class SubscriptionsApi extends runtime.BaseAPI {

    /**
     */
    async updatePLanRaw(requestParameters: UpdatePLanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['updatePLanRequest'] == null) {
            throw new runtime.RequiredError(
                'updatePLanRequest',
                'Required parameter "updatePLanRequest" was null or undefined when calling updatePLan().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/subscriptions/subscription`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePLanRequestToJSON(requestParameters['updatePLanRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updatePLan(requestParameters: UpdatePLanOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updatePLanRaw(requestParameters, initOverrides);
    }

}
